import { RelativeTimeThreshold } from './type';

export const SECONDS_A_MINUTE = 60;
export const SECONDS_A_HOUR = SECONDS_A_MINUTE * 60;
export const SECONDS_A_DAY = SECONDS_A_HOUR * 24;
export const SECONDS_A_WEEK = SECONDS_A_DAY * 7;

export const MILLISECONDS_A_SECOND = 1e3;
export const MILLISECONDS_A_MINUTE = SECONDS_A_MINUTE * MILLISECONDS_A_SECOND;
export const MILLISECONDS_A_HOUR = SECONDS_A_HOUR * MILLISECONDS_A_SECOND;
export const MILLISECONDS_A_DAY = SECONDS_A_DAY * MILLISECONDS_A_SECOND;
export const MILLISECONDS_A_WEEK = SECONDS_A_WEEK * MILLISECONDS_A_SECOND;

// English locales
export const MS = 'millisecond';
export const S = 'second';
export const MIN = 'minute';
export const H = 'hour';
export const D = 'day';
export const W = 'week';
export const M = 'month';
export const Q = 'quarter';
export const Y = 'year';
export const DATE = 'date';

// Plural types
export const ZERO = 'zero';
export const ONE = 'one';
export const TWO = 'two';
export const FEW = 'few';
export const MANY = 'many';
export const OTHER = 'other';

// threshold configs
export const DEFAULT_THRESHOLDS: RelativeTimeThreshold[] = [
  { relativeTimeKey: 'y', num: 11, unit: M },
  { relativeTimeKey: 'M', num: 3.5, unit: W },
  { relativeTimeKey: 'w', num: 6.5, unit: D },
  { relativeTimeKey: 'd', num: 22, unit: H },
  { relativeTimeKey: 'h', num: 45, unit: MIN },
  { relativeTimeKey: 'm', num: 45, unit: S },
  { relativeTimeKey: 's', num: 0, unit: S },
];

export const TIMERANGE_PLACEHOLDERS = ['%$1s', '%$2s'];
export const TIMEZONE_PLACEHOLDERS = ['%$1s', '%$2s'];

export const LOCALE_NAMES_SET = new Set([
  'af',
  'ar',
  'az',
  'bg',
  'bn',
  'ca',
  'ceb',
  'cs',
  'da',
  'de',
  'el',
  'en-GB',
  'en',
  'es-419',
  'es',
  'et',
  'fa',
  'fi',
  'fil',
  'fr-CA',
  'fr',
  'ga',
  'gu',
  'he',
  'hi',
  'hr',
  'hu',
  'id',
  'is',
  'it',
  'ja',
  'jv',
  'kk',
  'km',
  'kn',
  'ko',
  'lt',
  'lv',
  'ml',
  'mr',
  'ms',
  'my',
  'nb',
  'nl',
  'or',
  'pa',
  'pl',
  'pt-BR',
  'pt-PT',
  'pt',
  'ro',
  'ru',
  'sk',
  'sl',
  'sq',
  'sv',
  'sw',
  'ta',
  'te',
  'th',
  'tr',
  'uk',
  'ur',
  'uz',
  'vi',
  'zh-Hans',
  'zh-Hant',
]);
